import React from "react"
import PropTypes from "prop-types"
import { useMatch, Link } from "react-router-dom"
import { routes } from "router/routes"
import { Flex, Space } from "antd"
import { Text, Title } from "ui/Typography"
import { SettingOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import { corners } from "themes/variables"
import { useTranslation } from "react-i18next"

const BreadcrumbItem = ({ children, showDivider = true }) => (
  <Flex gap={corners.S} align="center">
    {showDivider && (
      <Text size="lg" className={styles.clientHeaderTitle}>
        ·
      </Text>
    )}
    <Text size="lg" className={styles.clientHeaderTitle}>
      {children}
    </Text>
  </Flex>
)

BreadcrumbItem.propTypes = {
  children: PropTypes.node,
  showDivider: PropTypes.bool,
}

export const ClientsBreadcrumb = () => {
  const { t } = useTranslation()
  const matchDetail = useMatch(routes.guideClientPath())
  const matchEdit = useMatch(routes.guideClientEditPath())
  const matchImport = useMatch(routes.guideImportClientHistory())
  const matchImportDetail = useMatch(routes.guideImportClientDetail())

  const isDetail = !!matchDetail || !!matchEdit
  const isImport = !!matchImport
  const isImportDetail = !!matchImportDetail

  return (
    <Space className="mb-4xl w-full" gap={corners.S} align="center">
      <SettingOutlined />
      <Link to={routes.guideClientsPath()} style={{ textDecoration: "none" }}>
        <Title level={5} className={`${styles.clientHeaderTitle} ${isDetail ? styles.colorPrimary : ""}`}>
          {t("clients.clients")}
        </Title>
      </Link>
      {isDetail && !isImport && <BreadcrumbItem>{t("clients.client_details")}</BreadcrumbItem>}
      {isImport && <BreadcrumbItem>{t("clients.import_history")}</BreadcrumbItem>}
      {isImportDetail && <BreadcrumbItem>{t("clients.client_import_details")}</BreadcrumbItem>}
    </Space>
  )
}

